import { colors } from 'assets/styled/tokens';
import styled from 'styled-components';

export const StyledGeneralPlanApplicationCell = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  line-height: 14px;
`;
export const StyledApplicationType = styled.span`
  font-weight: ${props => (props.isEmpty ? '400' : '600')};
  color: ${props => (props.isEmpty ? colors.gray : colors.carbon)};
`;
export const StyledCellDescription = styled.div`
  color: ${colors.gray};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
`;
